export function normalizeRole(role) {
  return String(role || '').trim().toLowerCase();
}

export function isAdminRole(role) {
  const normalized = normalizeRole(role);
  return normalized.includes('admin') || normalized.includes('administrador') || normalized === 'root';
}

export function isPortalRole(role) {
  const normalized = normalizeRole(role);
  return !!normalized && !isAdminRole(normalized);
}
